const _ = require('lodash');

const MESSAGE_TYPE = {
  LEGACY: 'legacy',
  ASSET: 'asset',
  RICH_TEXT: 'rich_text',
  REPLIES: 'replies',
  REPLY: 'reply',
  URL: 'url',
  FILE: 'file',
  SYSTEM: 'system',
  EVENT: 'event',
  CALL: 'call',
  SIGNATURE: 'signature',
  UNKNOWN: 'unknown',
};

const makeLegacyMessage = function (content) {
  return { content };
};

/**
 * Return supported message type of internal message
 */
const getMessageType = function (messagePayload) {
  const messageType = _.get(messagePayload, 'message_type');

  if (!messageType) {
    return MESSAGE_TYPE.LEGACY;
  }

  if (_.values(MESSAGE_TYPE).includes(messageType)) {
    return messageType;
  }

  return MESSAGE_TYPE.UNKNOWN;
};

const makeReplyMessage = function (content, postback) {
  return {
    message_type: 'reply',
    reply: {
      content,
      postback
    }
  };
};

const makeUrlMessage = function (link, name = 'link') {
  return {
    message_type: 'url',
    url: { link, name }
  };
};

const makeFileMessage = function (url) {
  return {
    message_type: 'file',
    file: { url, thumbnail: { url } }
  };
};


const makeRichTextMessage = function (content, attachments) {
  return {
    message_type: 'rich_text',
    rich_text: { content, attachments }
  };
};

const makeRepliesMessage = function (attachments) {
  return {
    message_type: 'replies',
    replies: { attachments }
  };
};

const makeCallMessage = function (content, room, type = 'video', created_at) {
  return {
    message_type: 'call',
    call: {
      content,
      namespace: room,
      type,
      created_at,
    },
  };
};

const makeSignatureMessage = function (label, title, integration, payload) {
  if (!integration) {
    throw new Error('makeMarkReadMessage: name of integration is missing');
  }

  if (!payload) {
    throw new Error(`makeMarkReadMessage: payload is missing for ${integration}`);
  }

  return {
    message_type: 'signature',
    signature: {
      label,
      title,
      integration,
      [integration]: payload,
    }
  };
};

const makeMarkReadMessage = function () {
  return {
    event: {
      action: 'messages.mark.read',
      content: '',
    },
    message_type: 'event',
  };
};

const textUrlMessage = function (name, url) {
  // name(http://link)
  return name + '(' + url + ')';
};

/**
 * Translate internal message payload to a text
 * to send external channel.
 */
const messagePayloadToText = function (text, payload, parseSystemMessage = false) {
  const messageType = _.get(payload, 'message_type');

  if (!messageType) {
    // legacy message
    return text + _.get(payload, 'content', '');
  }

  switch (messageType) {
  case MESSAGE_TYPE.ASSET: {
    return text + textUrlMessage(_.get(payload, 'asset.title', 'File'),
      _.get(payload, 'asset.file.payload.url', ''));
  }
  case MESSAGE_TYPE.URL: {
    return text + textUrlMessage(_.get(payload, 'url.name', 'File'),
      _.get(payload, 'url.link', ''));
  }
  case MESSAGE_TYPE.FILE: {
    return text + textUrlMessage(_.get(payload, 'file.name', 'File'),
      _.get(payload, 'file.url', ''));
  }
  case MESSAGE_TYPE.RICH_TEXT: {
    text += _.get(payload, 'rich_text.content', '');
    for (const message of _.get(payload, 'rich_text.attachments', [])) {
      text = messagePayloadToText(text, message, parseSystemMessage);
    }
    return text;
  }
  case MESSAGE_TYPE.REPLIES: {
    const list = _.get(payload, 'replies.attachments', []).map((m, i) => {
      return `${i+1}. ${_.get(m, 'reply.content')}`;
    });
    return text + list.join('\n');
  }
  case MESSAGE_TYPE.CALL: {
    return text + _.get(payload, 'call.content', '');
  }
  case MESSAGE_TYPE.SYSTEM: {
    if (parseSystemMessage) {
      return text + _.get(payload, 'system.content', '');
    }
  }
  }

  return text;
};

module.exports = {
  MESSAGE_TYPE,
  getMessageType,
  makeReplyMessage,
  makeUrlMessage,
  makeRichTextMessage,
  makeFileMessage,
  makeLegacyMessage,
  makeRepliesMessage,
  makeCallMessage,
  makeMarkReadMessage,
  textUrlMessage,
  messagePayloadToText,
  makeSignatureMessage,
};
